module.exports = __webpack_public_path__ + "static/assets/6e86af3defe1e404288b24b77e20450a.png";